import React from 'react';

interface PhoneNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

const formatValue = (input: string): string => {
  const digits = input.replace(/[^\d]/g, '');
  if (!digits) return '';
  // Allow variable country code length; split at first 1-3 digits
  let country = digits;
  let number = '';
  if (digits.length > 1) {
    country = digits.slice(0, Math.min(3, digits.length - 1));
    number = digits.slice(country.length);
  }
  let formatted = `+${country}`;
  if (number) formatted += `-${number}`;
  return formatted;
};

export const isValidPhoneNumber = (value: string): boolean => {
  return /^\+\d+-\d+$/.test(value);
};

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  onBlur,
  className,
  placeholder = '+1-5551234567',
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatValue(e.target.value);
    onChange(formatted);
  };

  return (
    <input
      type="tel"
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      className={className}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};

export default PhoneNumberInput;

